
// AI Service now calls Supabase Edge Function
// This keeps the API key secure on the backend

export const generateScreens = async (supabase, prompt, count = 3, brand = {}, imageFiles = []) => {
    const images = [];

    if (imageFiles && imageFiles.length > 0) {
        for (const file of imageFiles) {
            const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]);
                reader.onerror = error => reject(error);
            });
            images.push({
                data: base64,
                mimeType: file.type
            });
        }
    }

    try {
        const { data, error } = await supabase.functions.invoke('generate-screen', {
            body: {
                mode: 'generate',
                prompt,
                count,
                brand,
                images
            }
        });

        if (error) throw error;
        if (data.error) throw new Error(data.error);

        return data.data;
    } catch (error) {
        console.error("Error generating screens:", error);
        throw error;
    }
};

export const modifyScreen = async (supabase, screen, prompt, context = {}) => {
    try {
        const { data, error } = await supabase.functions.invoke('generate-screen', {
            body: {
                mode: 'modify',
                prompt,
                screen,
                context
            }
        });

        if (error) throw error;
        if (data.error) throw new Error(data.error);

        return data.data;
    } catch (error) {
        console.error("Error modifying screen:", error);
        throw error;
    }
};
